export default __webpack_public_path__ + "f8a04c8339b54d9ab21739730aa6db7a.png";